module.exports = __webpack_public_path__ + "img/home-employee.61687cfe.svg";